import { StrictPartial } from "../../common/optional";
import { User } from "../models";

export enum Role {
    admin = "admin",
    standard = "standard"
}

// NOTE: This should reflect what is in the db.
// I.e anything non-optional in the db, should be non optional here. Use MakeOptional for cases where something is partial

export type UserDatabaseModel = StrictPartial<_UserDatabaseModel>; // Obfuscated object

// Not to be exposed
interface _UserDatabaseModel {
    id: string;
    email: string;
    name: string;
    role: Role;
    roleRank: number;
    impersonating?: boolean;
}

export function userFromDatabaseModel(model: UserDatabaseModel): User {
    let _model = model as _UserDatabaseModel
    return {
        id: _model.id,
        email: _model.email,
        name: _model.name,
        role: _model.role,
        roleRank: _model.roleRank,
        impersonating: !!_model.impersonating,
    }
}